var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInternalTransferIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#1B2B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2035 9.49999L11.0155 12.688H27.5425V14.188H11.0285L14.2165 17.375L13.1555 18.436L9.21153 14.492L9.20553 14.5L8.14453 13.438L13.1445 8.43799L14.2035 9.49999Z",
    fill: "#3BB0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.971 23.313H8.45703V21.813H24.984L21.794 18.625L22.855 17.564L27.855 22.564L26.794 23.623L26.788 23.617L22.844 27.561L21.784 26.5L24.971 23.313Z",
    fill: "#3BB0FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalTransferIcon);
export default __webpack_public_path__ + "static/media/internal-transfer-icon.43f0d603098dfe2b4548cd7e006d7899.svg";
export { ForwardRef as ReactComponent };